import React from 'react';
import Geo from '../../components/geo/geoui';
import Chatbotui from '../../components/chatbotui/chatbotui';
import "./geo.css"


const GeoPage = () => {
    return (
        <main className="geo-page-container">
            <div className="geo-container">
                <Geo />
            </div>
            <div className="chatbot-container">
                <Chatbotui />
            </div>
        </main>
    );
};

export default GeoPage;